/**
 * Shared x axis for the "compare years" charts.
 *
 * The axis is the selected period itself, on its real dates. A compared season
 * starting in another year is moved onto it by a whole number of years, so every
 * record keeps its month/day and a period longer than one year stays continuous
 * (the old month/day-only projection onto 2000/2001 folded the second year back
 * over the first).
 */

const DATE_RE = /^\d{4}-\d{2}-\d{2}/;

export const isLeapYear = (year) => (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

/**
 * Moves `date` ("YYYY-MM-DD", optionally followed by a time) from a season that
 * starts in `sourceStartYear` onto the season that starts in `referenceStartYear`.
 *
 * Feb 29 landing on a common year has no calendar day of its own: it is placed at
 * noon of Feb 28 so it neither disappears nor overlaps the Feb 28 record.
 */
export function alignToReferenceYear(date, sourceStartYear, referenceStartYear) {
    const str = String(date);
    if (!DATE_RE.test(str)) return date;

    const shift = referenceStartYear - sourceStartYear;
    if (!shift) return str;

    const year = parseInt(str.slice(0, 4), 10) + shift;
    const monthDay = str.slice(5, 10);

    if (monthDay === '02-29' && !isLeapYear(year)) return `${year}-02-28 12:00:00`;
    return `${year}-${monthDay}${str.slice(10)}`;
}
